<template>
  <section class="section-wrapper">
    <b-container>
      <b-row>
        <b-col>
          <h2 class="heading">
            Recursos informativos para gestores, pacientes e profissionais de saúde
          </h2>
        </b-col>
      </b-row>
    </b-container>
    <b-container>
      <b-row>
        <b-col cols="12" lg="6" class="mb-4">
          <div class="resource-box exame">
            <p>Saiba mais sobre o exame citopatológico (Papanicolau)</p>
            <span><a :href="linkPdfExameCitopatologico" target="_blank">Baixar PDF</a></span>
            <div class="resource-box__background"></div>
          </div>
        </b-col>
        <b-col cols="12" lg="6" class="mb-4">
          <div class="resource-box vacina">
            <p>Saiba mais sobre a vacina contra o vírus do HPV</p>
            <span><a :href="linkPdfVacinacaoHpv" target="_blank">Baixar PDF</a></span>
            <div class="resource-box__background"></div>
          </div>
        </b-col>
        <b-col cols="12" lg="6" class="mb-4">
          <div class="resource-box teleconduta">
            <p>Telecondutas: Rastreamento do Câncer de Colo do Útero</p>
            <span><a :href="linkPdfTelecondutas" target="_blank">Baixar PDF</a></span>
            <div class="resource-box__background"></div>
          </div>
        </b-col>
        <b-col cols="12" lg="6" class="mb-4">
          <div class="resource-box monitoramento">
            <p>Monitoramento externo da qualidade de exames citopatológicos no RS</p>
            <span><a :href="linkPdfFluxoMonitoramento" target="_blank">Baixar PDF</a></span>
            <div class="resource-box__background"></div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
export default {
  name: 'informational-resources-section-cancer-colo-utero',
  data: () => ({
    linkPdfExameCitopatologico: '/recursos-informativos/cancer-colo-utero/exame-cp.pdf',
    linkPdfVacinacaoHpv: '/recursos-informativos/cancer-colo-utero/vacinacao-hpv.pdf',
    linkPdfTelecondutas: 'https://www.ufrgs.br/telessauders/documentos/telecondutas/tc_rastreamento_do_cancer_do_colo_do_utero.pdf',
    linkPdfFluxoMonitoramento: '/recursos-informativos/cancer-colo-utero/fluxo-monitoramento-qualidade-exames-citopatologicos-colo-do-utero.pdf',
  }),
};
</script>

<style lang="scss" scoped>
.section-wrapper {
  padding: 3rem 0;
}

.heading {
  color: $primary;
  font-weight: 600;
  font-size: 1.375rem;
  text-align: center;
  line-height: 1.36;
  margin-bottom: 1.5rem;
  padding: 0 1rem;
}

.resource-box {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  max-width: 430px;
  height: 240px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 2rem;
  text-align: center;
  color: $white;
  .resource-box__background {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center top;
    transition: all ease 200ms;
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, .3);
      opacity: 0;
      transition: opacity 200ms ease;
    }
  }
  &:hover {
    .resource-box__background {
      transform: scale(1.2);
      &::before { opacity: 1; }
    }
  }
  &.exame {
    .resource-box__background {
      background-image: url('@img/cancer-colo-utero/exame-citopatologico.jpg');
    }
  }
  &.vacina {
    .resource-box__background {
      background-image: url('@img/cancer-colo-utero/vacina-hpv.jpg');
    }
  }
  &.teleconduta {
    .resource-box__background {
      background-image: url('@img/cancer-colo-utero/telecondutas.png');
    }
  }
  &.monitoramento {
    .resource-box__background {
      background-image:
        linear-gradient(to bottom, rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.25)),
        url('@img/cancer-colo-utero/monitoramento-exames.jpg');
    }
  }
  p {
    max-width: 230px;
    margin: 0 auto 2rem;
    z-index: 1;
  }
  a {
    display: inline-block;
    color: $white;
    text-decoration: underline;
    position: relative;
    z-index: 1;
    &:before {
      content: '';
      width: 2px;
      height: 16px;
      background-color: $white;
      display: block;
      position: absolute;
      bottom: 4px;
      right: -20px;
    }
    &:after {
      content: '';
      width: 12px;
      height: 12px;
      display: block;
      border-right: 2px solid $white;
      border-bottom: 2px solid $white;
      transform: rotate(45deg);
      position: absolute;
      right: -25px;
      bottom: 4px;
    }
  }
}

@include media-breakpoint-up(lg) {
  .section-wrapper {
    padding: 5rem 0 8rem;
    background-image: linear-gradient(to bottom, #FFF, #B9E2DD 500%);
  }

  .heading {
    font-size: 2.25rem;
    max-width: 680px;
    margin-left: auto;
    margin-right: auto;
    padding: 0;
    margin-bottom: 4rem;
  }

  .resource-box {
    font-size: 1.25rem;
    max-width: none;
    p {
      max-width: 320px;
    }
  }
}
</style>
